import * as ko from 'knockout';
import { toastService } from '../../../toastService';
import * as ROUTES from '../../routes';
import { UIAction } from '../../uiAction';
import * as i18next from './../../../i18n/i18n';

export const WIDGET_NAME = 'ui-superuser-examorderoverview';

export type IParamsInner = undefined;

export type IParams = ROUTES.IRoutableParams<IParamsInner>;

export class ExamOrderOverviewRoute implements ROUTES.IRoute<IParamsInner> {
    public readonly widgetName = WIDGET_NAME;
    public readonly title = ko.pureComputed(() => {
        return i18next.t(['ui.superuser.examorderoverview.EXAM_ORDER']);
    });

    private readonly showHelp = new UIAction(undefined, async () => {
        const msg = i18next.t(['ui.superuser.examorderoverview.IF_THE_CONTENT_OF_ONE_COLUMN_IS_NOT_COMPLETELY_VISIBLE_YOU_CAN_ADJUST_THE_WIDTH_BY_PULLING_THE_LINE']);

        toastService.info(msg);
    });

    public readonly routeActions = ko.pureComputed(() => {
        return [
            {
                icon: 'help',
                caption: i18next.t(['ui.superuser.examorderoverview.HELP']),
                action: this.showHelp
            }
        ];
    });

    constructor(readonly widgetParams: IParamsInner) {
    }
}

export const FACTORY = ROUTES.registerRoute<{}>({
    route: '/superuser/examorder',
    toParams: map => ({
    }),
    fromParams: (p, map) => {
    },
    create: async p => {
        return new ExamOrderOverviewRoute(undefined);
    },
});
